// extracted by mini-css-extract-plugin
module.exports = {"mediaBlock":"Media2Up_mediaBlock__16_Tl","blocks":"Media2Up_blocks__3c0-n"};